import { render, staticRenderFns } from "./pagesLayout.vue?vue&type=template&id=061e8d40&"
import script from "./pagesLayout.vue?vue&type=script&lang=js&"
export * from "./pagesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports